<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6>
                <v-text-field label="知识产权名称" required :rules="rules.name" v-model="item.name"/>
              </v-flex>
              <v-flex xs3>
                <v-autocomplete
                  label="知识产权类型"
                  clearable
                  :rules="rules.required"
                  v-model="item.typeId"
                  item-text="name"
                  item-value="dbid"
                  :items="typeItems"
                />
              </v-flex>
              <v-flex xs3>
                <v-select
                  label="知识产权属地"
                  item-text="name"
                  item-value="dbid"
                  :rules="rules.required"
                  :items="[{dbid:'gn',name:'国内'},{dbid:'gw',name:'国外'}]"
                  v-model="item.affiliation"
                  persistent-hint
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  label="归属部门"
                  clearable
                  :rules="rules.required"
                  v-model="item.departmentId"
                  item-text="name"
                  item-value="dbid"
                  :items="deptItems"
                />
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  label="代理机构"
                  clearable
                  :rules="rules.required"
                  v-model="item.agencyId"
                  item-text="name"
                  item-value="dbid"
                  :items="agencyItems"
                />
              </v-flex>
              <v-flex xs12>
                <x-orgs-edit
                  label="归属单位列表"
                  v-model="item.orgs"
                  hint="填写归属单位列表"
                />
              </v-flex>
              <v-flex xs12>
                <x-apps-edit
                  label="参与人列表"
                  v-model="item.apps"
                  hint="填写参与人列表"
                />
              </v-flex>
              <v-flex xs12>
                <v-textarea>
                  label="专利来源"
                  :rules="rules.source"
                  v-model="item.source"
                  persistent-hint
                  :counter=250
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <x-uploader
                  label="附件列表"
                  :action="fileUri"
                  v-model="item.attachments"
                  :size="Number(100)"
                  description="附件大小不超过 100M.(上传知识产权申请书和多单位合作申请的合同扫描件)"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import XAppsEdit from '../appsEdit'
  import XAppsView from '../appsView'
  import XOrgsEdit from '../orgsEdit'
  import XOrgsView from '../orgsView'
  import mixin from '@/mixin'
  import XUploader from '@/components/global/Uploader'
  import XUserSelectForm from '@/components/global/UserSelectForm'
  const  baseUri= '/api/inte/intellectualApp'
  const statusUri = '/api/code/status';
  const deptUri = '/api/syst/department';
  const inteTypeUri = '/api/inte/intellectualType';
  const agencyUri= '/api/inte/agency'
  export default {
    mixins: [mixin.edit(baseUri)],

    components: {XAppsEdit,XAppsView,XOrgsEdit,XOrgsView,XUploader, XUserSelectForm},
    data() {
      return {
        formValid: false,

        fileUri: '/api/inte/file',
        item: {},
        freshItem: {
          "name": "",
          "typeId":"",
          "type": "",
          "affiliation": "",
          "departmentId": "",
          "department": "",
          "agencyId": "",
          "agency": "",
          "source": "",
          "contractId":"",
          "submitDate": "",
          "status": "",
          "outcomeState": "",
          "apps": [],
          "orgs": [],
          "agentId": "",
          "agent": "",
          "managerId": "",
          "manager": "",
          "processStateId": "",
          "processState": "",
          "outcomeStateId": "",
          "processStateDate": "",
          "number": "",
          "notes":"",
          "attachments": []
        },

        stateMap: {
          unsubmitted: "未提交",
          awaiting: "等待审核",
          checked: "已审核",
          returned: "驳回"
        },
        affiliationMap:{
          gn: "国内",
          gw: "国外"
        },
        leader: {},

        typeItems: [],
        agencyItems: [],
        deptItems: [],


        /**
         * 验证规则
         */
        rules: {
          name: [
            v => !!v || '必填项。',
            v => (v && v.length <= 255) || '长度必须小于255个字符。'
          ],
          typeId: [v => !!v || '必填项。'],
          departmentId: [v => !!v || '必填项。'],
          agencyId: [v => !!v || '必填项。']
        }
      }
    },

    created() {
      // 加载审核状态
      this.axios.all([
        this.axios.get(statusUri, {params: {sort: 'rank.asc'}}),
        this.axios.get(inteTypeUri, {params: {sort: 'order.asc'}}),
        this.axios.get(agencyUri, {params: {sort: 'order.asc'}}),
        this.axios.get(deptUri, {params: {limit: 65535, disabled: 'F', sort: 'rank.asc'}}),
      ]).then(
        this.axios.spread(
          (rspStaus,rspType,rspAgency, rspDept) => {
            this.statusItems = rspStaus.data.items;
            this.typeItems = rspType.data.items;
            this.agencyItems = rspAgency.data.items;
            this.deptItems = rspDept.data.items;
          }
        )
      )
    },

    watch: {

    },

    computed: {

    },

    methods: {
      // mixin 加载数据后调用
      afterGetData(data) {

      },
    }
  }
</script>
